<template>
  <div>
    <v-client-table :data="otExpeditions"
      class='mgt-10px column is-12 is-paddingless' :columns="columns"
      :options="options">
      <template #selected="{ row }">
        <b-checkbox v-model="row.selected"
          class="has-text-centered" @input="selectionOtExpedition(row)">
        </b-checkbox>
      </template>
      <template #code="{ row }">
        <router-link-blank v-if="row.id"
          :to="{ name: 'c.logistique.ordre_travail-tech', params: { id: row.id }}"
          class="lien"
          :message="row.code
                ? row.code : null">
        </router-link-blank>
      </template>
      <template #etat = "{ row }">
        {{ getLibelleEtat(row.etat) }}
      </template>
      <template #site="{ row }">
        <router-link-blank
          :to="{
            name: 'c.bodac.clients/contacts-client',
            params: { id: row.lieuDeStockageId }
          }"
          class="lien"
          :message="row.lieuDeStockageNomCommercial"
        >
        </router-link-blank>
      </template>
      <template #quantite="{ row }">
        <div class="has-text-right">
          {{ row.quantite }}
        </div>
      </template>
      <template #expedie = "{ row }">
        <div class="has-text-centered">
          <btn-action-icon
            :permission="ORDRE_TRAVAIL_EXPEDITION.maj"
            @is-click="expedieOt(row)"
            icon-type="is-primary"
            :tooltip-label="$t('listeExpedition.table.childRow.expedie')"
            icon="cube-send">
          </btn-action-icon>
        </div>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, NO_PAGINATION, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SET_OT_SELECT } from '@/store/modules/logistique/otExpeditionLivraison-mutation-type';
import { ORDRE_TRAVAIL_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

const OtExpeditionLivraison = createNamespacedHelpers('otExpeditionLivraison');

export default {
  name: 'childRowExpeditionLivraison',
  data() {
    return {
      selectAllValue: false,
      ORDRE_TRAVAIL_EXPEDITION,
    };
  },
  components: {
    routerLinkBlank,
    BtnActionIcon,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  methods: {
    ...OtExpeditionLivraison.mapMutations({
      setOtSelect: SET_OT_SELECT,
    }),
    expedieOt(row) {
      this.$emit('expedie', [row.id]);
    },
    selectionOtExpedition(row) {
      const lieuLivraisonId = row.lieuDeLivraisonId ?? row.lieuDeStockageId;
      const otId = row.id;
      this.setOtSelect({
        lieuLivraisonId,
        otId: otId,
      });
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.data.otExpeditions.forEach((el) => {
        el.selected = this.selectAllValue;
      });
    },
    getLibelleEtat(etatOt) {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === etatOt;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : '';
    },
  },
  computed: {
    columns() {
      return ['selected', 'code', 'typeOtLibelle', 'etat', 'site', 'quantite', 'expedie'];
    },
    otExpeditions() {
      return cloneDeep(this.data.otExpeditions);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeExpedition.table.childRow.code'),
          typeOtLibelle: this.$i18n.t('listeExpedition.table.childRow.type'),
          etat: this.$i18n.t('listeExpedition.table.childRow.etat'),
          quantite: this.$i18n.t('listeExpedition.table.childRow.quantite'),
          site: this.$i18n.t('listeExpedition.table.childRow.site'),
          expedie: '',
          selected: () => {
            return '';
          },
        },
        filterable: false,
        pagination: {
          show: false,
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortable: [],
        columnsClasses: {
          quantite: 'colonneWidth270pxMoinsMarge',
          expedie: 'colonneSelected',
        },
      };
    },
  },
};
</script>

<style scoped>

</style>
